function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg50D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "50d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.218,
    height: 33.16,
    viewBox: "0 0 30.218 33.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184503"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184502"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184498"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14447",
    d: "M268.217 191.183a4.444 4.444 0 0 0-4.388-3.437 4.567 4.567 0 0 0-2.794.945 7.952 7.952 0 0 0-7.1-4.255 7.822 7.822 0 0 0-7.853 6.65 5.282 5.282 0 0 0-4.235 5.085 5.335 5.335 0 0 0 5.417 5.215h19.383a5.335 5.335 0 0 0 5.417-5.215 5.263 5.263 0 0 0-3.847-4.988z",
    transform: "translate(-241.843 -179.032)",
    style: {
      fill: "#d32f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14524",
    d: "M285.556 46.865a5.149 5.149 0 0 1 2.589-.686 5.082 5.082 0 0 1 4.889 3.57 6.019 6.019 0 0 1 .619.266 6.758 6.758 0 1 0-11.353-6.162 8.347 8.347 0 0 1 3.256 3.012z",
    transform: "translate(-265.952 -38.43)",
    style: {
      fill: "#ff8826"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184624"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 47 \\u2013 3"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14451",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 27.192 11.419)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14452",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 25.792 6.976)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14453",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 30.659 5.637)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14454",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 31.342 10.02)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14455",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 29.259 1.194)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14451",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 33.304 .747)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14452",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 31.904 -3.696)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14453",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 36.77 -5.035)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14454",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 37.454 -.652)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14525",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 34.654 4.505)",
    style: {
      fill: "#283593"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14455",
    d: "m.053.492 1.956 3.085c.229.361.807.027.576-.337L.629.155C.4-.206-.177.128.053.492z",
    transform: "rotate(-57 35.37 -9.478)",
    style: {
      fill: "#283593"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184501"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184499"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14448",
    d: "M266.03 191.266a6.281 6.281 0 0 1 5.088-2.716.376.376 0 0 0 0-.752 7.077 7.077 0 0 0-5.738 3.088c-.279.4.373.774.65.38z",
    transform: "translate(-259.051 -181.497)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184500"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14449",
    d: "M246.365 218.167a4.088 4.088 0 0 1 1.917-3.406c.407-.26.03-.912-.38-.65a4.866 4.866 0 0 0-2.289 4.055.376.376 0 0 0 .752 0z",
    transform: "translate(-244.606 -200.747)",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg50D);
export default __webpack_public_path__ + "static/media/50D.31fad3c3fa727ebf9cfdc89e74fae58b.svg";
export { ForwardRef as ReactComponent };